<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
            type="text/css"/>

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css"
            rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

    </head>

    <body @contextmenu.prevent data-sidebar="dark">

    <!-- Begin page -->
    <div id="layout-wrapper">

      <NavigationBar/>

      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== -->
      <div id="content" class="content-minimize">

        <div class="page-content">
          <div class="container-fluid">

            <!-- start page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Assets</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                      <li class="breadcrumb-item active">Assets</li>
                      <li class="breadcrumb-item active">Asset Tracking</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>
            <!-- end page title -->

            <!-- stats cards -->
            <div class="row">
              <!-- Total Assets -->
              <div class="col-lg-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Total Assets</p>
                        <h5 class="mb-0">1,250</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                          <i class="mdi mdi-archive"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Assets Not in Good Condition -->
              <div class="col-lg-3 col-md-6">
                <div class="card blog-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Not in Good Condition</p>
                        <h5 class="mb-0">85</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-danger rounded-circle text-white font-size-20">
                          <i class="mdi mdi-alert-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Unassigned Assets -->
              <div class="col-lg-3 col-md-6">
                <div class="card blog-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Unassigned Assets</p>
                        <h5 class="mb-0">320</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                          <i class="mdi mdi-help-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Assets Past Warranty Period -->
              <div class="col-lg-3 col-md-6">
                <div class="card blog-stats-wid">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">Past Warranty Period</p>
                        <h5 class="mb-0">240</h5>
                      </div>
                      <div class="avatar-sm ms-auto">
                        <div class="avatar-title bg-dark rounded-circle text-white font-size-20">
                          <i class="mdi mdi-calendar-remove"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- end of stats -->
            <div class="row">
              <div class="col-12">
                <div class="card">

                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">

                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <div class="flex-grow-1">
                        <div class="search-box mb-0 me-3">
                          <div class="position-relative">
                            <input type="text" class="form-control bg-light border-light rounded" placeholder="Search..." fdprocessedid="husj3l" spellcheck="false" data-ms-editor="true">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex">
                        <div class="d-flex align-items-center me-3 pe-3">
                          <div>
                            <div class="float-end d-flex ">
                              <div class="input-group fw-semibold text-uppercase me-3">
                                <label class="input-group-text text-uppercase">Department</label>
                                <select class="form-select " style="width: 200px;">
                                  <option selected="selected" value="">All Departments</option>
                                  <option value="65">Finance &amp; Economic Planning</option>
                                  <option value="67">Governance, Administration, Communication &amp; Devolution</option>
                                  <option value="73">Education, Human Capital Development &amp; Vocational Training</option>
                                  <option value="62">Blue Economy, Fisheries, Mining &amp; Digital Economy</option>
                                  <option value="66">Roads, Public Works, Transport &amp; Infrastructure</option>
                                  <option value="61">Youth, Sports, Talent Development, Gender Inclusivity, Cultural Heritage &amp; Social Services</option>
                                  <option value="63">Water, Irrigation, Sanitation, Environment, Energy, Forestry &amp; Climate Change</option>
                                  <option value="68">Public Health &amp; Medical Services</option>
                                  <option value="64">Lands, Physical Planning, Housing &amp; Urban Development</option>
                                  <option value="69">Trade, Industry, Tourism, Co-Operative Development and Marketing</option>
                                  <option value="70">Agriculture and Livestock Production</option>
                                  <option value="72">Office of the County Secretary and Head of Public Service</option>
                                </select>
                              </div>





                            </div>
                          </div>
                        </div>
                        <button data-bs-toggle="modal" data-bs-target=".download-modal" type="button" class="btn btn-primary dropdown-toggle option-selector me-3 text-capitalize">
                          <i class="bx bxs-download "></i> <span class="pl-1 d-md-inline">Download Report</span>
                        </button>

                        <!-- Add Asset Button -->
                        <button data-bs-toggle="modal" data-bs-target="#modal-add-asset" type="button" class="btn btn-success dropdown-toggle option-selector me-3 text-capitalize">
                          <i class="bx bx-plus"></i> <span class="pl-1 d-md-inline">Add Asset</span>
                        </button>





                      </div>


                    </div>
                    <div class="btn-toolbar p-3 align-items-center d-none animated delete-tool-bar" role="toolbar">
                      <button type="button" data-bs-toggle="modal" data-bs-target=".download-modal" class="btn btn-primary waves-effect btn-label waves-light me-3"><i class="mdi mdi-printer label-icon"></i> Print Selected Invoices</button>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="table-responsive ">
                      <table class="table align-middle table-hover contacts-table table-striped text-nowrap" id="datatable-buttons">
                        <thead class="table-light">
                        <tr class="table-dark">
                          <th scope="col">Identifier</th>
                          <th scope="col">Item</th>
                          <th scope="col">Employee</th>
                          <th scope="col">Purchase Date</th>
                          <th scope="col">Warranty End</th>
                          <th scope="col">Purchase Price</th>
                          <th scope="col">Description</th>
                          <th>Condition</th>
                          <th scope="col">Department</th>
                          <th scope="col">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <th>KAD123T</th>
                          <td>Car</td>
                          <td>Kelvin Otati</td>
                          <td>12 Feb 2025</td>
                          <td>12 Feb 2030</td>
                          <td>KES 5,678,060</td>
                          <td>Toyota Hilux</td>
                          <td><span class="badge rounded-pill bg-success text-uppercase fw-bold">Good</span></td>
                          <td>Finance</td>
                          <td></td>
                        </tr>
                        <tr>
                          <th>LTY456P</th>
                          <td>Laptop</td>
                          <td>Jane Wanjiru</td>
                          <td>25 Apr 2023</td>
                          <td>25 Apr 2026</td>
                          <td>KES 150,000</td>
                          <td>Dell Latitude 7420</td>
                          <td><span class="badge rounded-pill bg-warning text-uppercase fw-bold">Needs Repair</span></td>
                          <td>IT</td>
                          <td></td>
                        </tr>
                        <tr>
                          <th>PRT789M</th>
                          <td>Printer</td>
                          <td>Michael Kimani</td>
                          <td>15 Jun 2021</td>
                          <td>15 Jun 2024</td>
                          <td>KES 85,000</td>
                          <td>HP LaserJet Pro</td>
                          <td><span class="badge rounded-pill bg-danger text-uppercase fw-bold">Out of Service</span></td>
                          <td>Admin</td>
                          <td></td>
                        </tr>
                        <tr>
                          <th>DSK321A</th>
                          <td>Office Desk</td>
                          <td>Unassigned</td>
                          <td>10 Sep 2022</td>
                          <td>10 Sep 2027</td>
                          <td>KES 30,000</td>
                          <td>Mahogany Executive Desk</td>
                          <td><span class="badge rounded-pill bg-info text-uppercase fw-bold">New</span></td>
                          <td>Procurement</td>
                          <td></td>
                        </tr>
                        <tr>
                          <th>PHN555X</th>
                          <td>Mobile Phone</td>
                          <td>David Mwangi</td>
                          <td>5 Dec 2023</td>
                          <td>5 Dec 2025</td>
                          <td>KES 75,000</td>
                          <td>Samsung Galaxy S22</td>
                          <td><span class="badge rounded-pill bg-success text-uppercase fw-bold">Good</span></td>
                          <td>Marketing</td>
                          <td></td>
                        </tr>
                        <tr>
                          <th>CH123Y</th>
                          <td>Chair</td>
                          <td>Unassigned</td>
                          <td>8 Nov 2020</td>
                          <td>8 Nov 2025</td>
                          <td>KES 12,000</td>
                          <td>Ergonomic Office Chair</td>
                          <td><span class="badge rounded-pill bg-success text-uppercase fw-bold">Good</span></td>
                          <td>HR</td>
                          <td></td>
                        </tr>
                        <tr>
                          <th>PRJ998Z</th>
                          <td>Projector</td>
                          <td>James Otieno</td>
                          <td>20 Jul 2019</td>
                          <td>20 Jul 2022</td>
                          <td>KES 90,000</td>
                          <td>Epson EB-X41</td>
                          <td><span class="badge rounded-pill bg-danger text-uppercase fw-bold">Out of Warranty</span></td>
                          <td>Training</td>
                          <td></td>
                        </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

            <!-- end row -->
          </div>
          <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

        <!-- Add Asset Modal -->
        <div class="modal fade" id="modal-add-asset" tabindex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="addAssetModalLabel">Add New Asset</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <form id="addAssetForm">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label for="assetIdentifier" class="form-label">Identifier</label>
                      <input type="text" class="form-control" id="assetIdentifier" placeholder="Enter Asset ID" required>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="assetItem" class="form-label">Item Name</label>
                      <input type="text" class="form-control" id="assetItem" placeholder="Enter Item Name" required>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="employee" class="form-label">Assigned Employee</label>
                      <input type="text" class="form-control" id="employee" placeholder="Employee Name">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="purchaseDate" class="form-label">Purchase Date</label>
                      <input type="date" class="form-control" id="purchaseDate" required>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="warrantyEnd" class="form-label">Warranty End</label>
                      <input type="date" class="form-control" id="warrantyEnd">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="purchasePrice" class="form-label">Purchase Price (KES)</label>
                      <input type="number" class="form-control" id="purchasePrice" placeholder="Enter Price" required>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="assetDescription" class="form-label">Description</label>
                      <input type="text" class="form-control" id="assetDescription" placeholder="Brief Description">
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="assetCondition" class="form-label">Condition</label>
                      <select class="form-select" id="assetCondition">
                        <option value="New">New</option>
                        <option value="Good">Good</option>
                        <option value="Needs Repair">Needs Repair</option>
                        <option value="Out of Service">Out of Service</option>
                      </select>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label for="department" class="form-label">Department</label>
                      <input type="text" class="form-control" id="department" placeholder="Enter Department Name" required>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="submit" class="btn btn-primary">Save Asset</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer ">
          <div class="container-fluid ">
            <div class="row ">
              <div class="col-sm-6 ">

              </div>
              <div class="col-sm-6 ">
                <div class="text-sm-end d-sm-block ">
                  2025
                </div>
              </div>
            </div>
          </div>
        </footer>

      </div>
      <!-- end main content-->

    </div>
    <!-- END layout-wrapper -->

    </body>

  </div>
</template>

<script>

</script>

